var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 14.0001C4.41658 14.0001 3.67492 14.7501 3.67492 15.6667C3.67492 16.5834 4.41658 17.3334 5.33325 17.3334C6.24992 17.3334 6.99992 16.5834 6.99992 15.6667C6.99992 14.7501 6.24992 14.0001 5.33325 14.0001ZM0.333252 1.50008C0.333252 1.95842 0.70825 2.33342 1.16659 2.33342H1.99992L4.99992 8.65841L3.87492 10.6917C3.26659 11.8084 4.06659 13.1667 5.33325 13.1667H14.4999C14.9583 13.1667 15.3333 12.7917 15.3333 12.3334C15.3333 11.8751 14.9583 11.5001 14.4999 11.5001H5.33325L6.24992 9.8334H12.4583C13.0833 9.8334 13.6333 9.4917 13.9166 8.97508L16.8999 3.56675C16.9701 3.44044 17.0062 3.29797 17.0044 3.15346C17.0027 3.00895 16.9633 2.86739 16.89 2.7428C16.8168 2.61821 16.7123 2.5149 16.5869 2.4431C16.4614 2.37129 16.3194 2.33349 16.1749 2.33342H3.84159L3.28325 1.14175C3.21628 0.999499 3.11017 0.879279 2.97734 0.795159C2.84452 0.711039 2.69047 0.666499 2.53325 0.666749H1.16659C0.70825 0.666749 0.333252 1.04175 0.333252 1.50008ZM13.6666 14.0001C12.7499 14.0001 12.0083 14.7501 12.0083 15.6667C12.0083 16.5834 12.7499 17.3334 13.6666 17.3334C14.5833 17.3334 15.3333 16.5834 15.3333 15.6667C15.3333 14.7501 14.5833 14.0001 13.6666 14.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.1e39ba74c70a85604880034912200968.svg";
export { ForwardRef as ReactComponent };